<template>
    <div class="relative bg-black overflow-hidden pb-[110%] sm:pb-[50%]">
        <button
            v-if="previousPhoto"
            @click="back"
            class="absolute h-full left-0 z-[5] p-4 bg-red-500 bg-opacity-0 hover:bg-gray-100 hover:bg-opacity-25"
        >
            <icon class="h-8 w-8 p-2 bg-gray-100 text-gray-900 rounded-full" type="chevron-left" />
        </button>

        <button
            v-if="nextPhoto"
            @click="forward"
            class="absolute h-full right-0 z-[5] p-4 bg-red-500 bg-opacity-0 hover:bg-gray-100 hover:bg-opacity-25"
        >
            <icon class="h-8 w-8 p-2 bg-gray-100 text-gray-900 rounded-full" type="chevron-right" />
        </button>

        <img
            v-for="(photo, index) in photos"
            :key="photo.id"
            :src="photo.url"
            :alt="photo.name"
            class="absolute inset-0 w-full h-full object-contain object-center transition-translate ease-in-out duration-1000"
            :style="{ transform: `translate(${(index - currentPhotoIndex) * 100}%)`}"
        >
    </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { includes } from 'lodash'

const props = defineProps({
    photos: {
        type: Object,
        required: true
    }
})

const currentPhotoIndex = ref(0)

const previousPhoto = computed(() => {
    return props.photos.find((photo, index) => index == currentPhotoIndex.value - 1)
})

const nextPhoto = computed(() => {
    return props.photos.find((photo, index) => index == currentPhotoIndex.value + 1)
})

const back = () => {
    if(! previousPhoto.value) return
    currentPhotoIndex.value = currentPhotoIndex.value - 1
}

const forward = () => {
    if(! nextPhoto.value) return
    currentPhotoIndex.value = currentPhotoIndex.value + 1
}

const getClasses = (photo) => {
    if(! includes(photosOnScreen, photo)) return 'hidden'
    return {
        'block -translate-x-full': (previousPhoto && photo.id == previousPhoto.id),
        'block translate-x-0': (currentPhoto && photo.id == currentPhoto.id),
        'block translate-x-full': (nextPhoto && photo.id == nextPhoto.id),
    }
}

if(props.photos.length > 1) {
    window.addEventListener('keyup', (e) => {
        if(['ArrowRight'].includes(e.key)) {
                forward()
        }

        if(['ArrowLeft'].includes(e.key)) {
                back()
        }
    })
}
</script>
